export default __webpack_public_path__ + "static/media/ISEO_CLASS-8_SYLLABUS_2025-26.73815471.pdf";